import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import { serviceURLService } from '../service/serviceURL';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import * as $ from 'jquery';
declare var $: any;

@Component({
  selector: 'app-hospital-locator',
  templateUrl: './hospital-locator.component.html',
  styleUrls: ['./hospital-locator.component.css']
})
export class HospitalLocatorComponent implements OnInit {
  video: string = "https://hospital.securenow.in/"
  
  hospitalFirstFold =  true;
  hospitalSecondFold: boolean;
  modalContent =  false;
  modalFilterContainer= false;
  modalMapContent = false;
  moreHospitalData = false;
  searchText;
  searchHospital;
  cityList:any = [];
  cityFilter: string[];
  hidethis = true;
  users:any = []
  order: boolean= false;
  insurerList: boolean = true;
  private readonly baseUrl = 'https://securenow.in/hospital/city';
  selectedDataUser: any;
  showInsurer = false;
  cityData = true
  selectedCityList = '';
  hData: any;
  selectedCity: any = [];
  selectedInsurer: any = [];
  searchFilter: any;
  selectInsurerName: any=[];
  redirectionLinks: any=[];
  dataToSlide: any=[];
  isDisabled= true;
  isClinetNFI = false;
  private onDestroy$: Subject<void> = new Subject<void>();
  
  constructor (private http: HttpClient, private serviceURLService: serviceURLService) {}
  getInsurer(){
    this.showInsurer = true;
    this.cityData = false;
  }
  getCityList(){
    this.showInsurer = false;
    this.cityData = true;
  }
  openSortingModal(){
    this.modalContent = true;
    console.log('clicked');
    this.sortArrayOfObjects(this.users.data, "srNo");
   
  }

  sortArrayOfObjects = (arr, key) => {
    if(!this.order) {
      return arr.sort((a, b) => {
        this.order = true;
        return a[key] - b[key];
      });
    }
    else {
      return arr.sort((a, b) => {
        this.order = false;
        return b[key] - a[key];
      });
    }  
  };

  dataToSlidefunc(){
    var value= this.dataToSlide
    if(value==0){
      value=1
    }
    else if(value==1){
      value=2
    }
    else if(value==2){
      value=3
    }
    else if(value==3){
      value=0
    }
    this.dataToSlide=value
    return this.dataToSlide
  }

  closeModal(){
    this.modalContent = false;
    this.modalFilterContainer = false;
    this.modalMapContent = false;
    this.moreHospitalData = false;
  }
  openMapModal(){
    this.modalMapContent = true;
  }
  viewMoreData(dataUser){
    this.selectedDataUser =  dataUser;
    this.moreHospitalData = true;
    console.log(this.selectedDataUser);
  }
 
  openFilterModal(){
    this.modalFilterContainer = true;
    this.getCities();
  }
  getUrl() {
    return "url('../assets/images/map_bg_new.png')";
  }
                 

  onCheckCityList(event){
    console.log(event)
    this.selectedCity.push(event.target.ngValue);
  }
  
  setDataForResdirection(){
    this.redirectionLinks={
      care:'https://www.careinsurance.com/health-plan-network-hospitals.html',
      icici: 'https://www.icicilombard.com/cashless-hospitals',
      bajaj: 'https://www.bajajallianz.com/branch-locator.html',
      star: 'https://www.starhealth.in/network-hospitals',
      Hdfc: 'https://www.hdfcergo.com/#network-branches-id',
      adityaBirla: 'https://www.adityabirlacapital.com/healthinsurance/#!/hs-our-network',
      reliance: 'https://messenger.brobotinsurance.com/GeoLocator/locator/Network_hospital',
      Max_health: 'https://rules.nivabupa.com/hospital-network/',
      royalSundaram: 'https://www.royalsundaram.in/cashless-hospital',
      Paramount_Newlogo: 'https://www.paramounttpa.com/Home/ProviderNetwork.aspx',
      vipul: 'https://www.vipulmedcorp.com/public/networklist.aspx',
      Medi_assist : 'https://mediassisttpa.in/hospital/',
      raksha: 'https://www.rakshatpa.com/WebPortal/Login/search_PPN',
      FHPL: 'https://fhpl.net/',
      vidalHealth: 'https://vidalhealthtpa.com/vidalhealthtpa/network-hospital.html',
      medsave: 'https://www.medsave.in/NetworkHospital.aspx',
      park: 'http://www.parkmediclaim.co.in/Search/Hospital',
      alankit: 'http://www.alankithealthcare.com/hospital-list.aspx',
      Unitedhealth: 'https://www.uhcpindia.com/web/Enrollment/HospitalNetworksNew.aspx',
      healthIndia: 'https://www.healthindiatpa.com/Hospital_Search.aspx',
      VisionTpa: 'https://visiontpa.in/NetworkServices.aspx',
      iffcoTokio:'https://www.iffcotokio.co.in/contact-us?tab=hospital',
      digit: 'https://www.godigit.com/health-insurance/digit-cashless-network-hospitals-list#nw-hospital',
      manipal:'https://www.manipalcigna.com/',
      future:'https://general.futuregenerali.in/hospital-locator',
      geniss:'https://www.geninsindia.com/networkhospital.aspx',
      sbi:'https://www.sbigeneral.in/contact-us/hospital',
      tataLogo:"https://www.tataaig.com/locator/cashless-network-hospitals",
      cholo:"https://www.cholainsurance.com/cashless-hospitals/",
      mdIndia:"https://mdindiaonline.com/Hospital.aspx"
    }
  }
  selectInsurer(event){
    this.selectInsurerName.length=0
    this.selectInsurerName.push(event.target.id)
    
    this.isDisabled=false
    console.log(this.selectInsurerName)
  }

  navigateToInsurer(){
    if(!this.selectInsurerName[0]){
      console.log('button is disabled')
    }
    else{
    var insurerName=this.selectInsurerName[0].toString()
    if(this.redirectionLinks.hasOwnProperty(insurerName)){
      let redirectionURL=this.redirectionLinks[insurerName]
      window.location.href=redirectionURL
    }
}
}
  onCheckInsurerName(event){
    this.selectedInsurer.push(event.target.ngValue);
  }
  
  insurerName = ['Bajaj Allianz General Insurance Co Ltd','Religare', 'Aegon Life Insurance Company','Aviva Life Insurance Company India Limited', 'BAGIC'];
  getCities() {
    this.serviceURLService.getCities().pipe(takeUntil(this.onDestroy$)).subscribe(
      (success: any) => {
        console.log(success);
        this.cityList = success.data.cityList;
        console.log(this.cityList);
      }, error => {
        console.log('error', error)
      }
    )
  }

  
  
  hospitalData() {
    let sendData = {
      name: this.searchFilter,
      city: this.selectedCity.length > 0 ? this.selectedCity : [],
      insurer: this.selectedInsurer.length > 0 ? this.selectedInsurer: []
    };
    this.http.post(
      this.baseUrl,
      sendData
      ).pipe(takeUntil(this.onDestroy$)).subscribe(data => {
        console.log("successful");
        this.users = data;    
        this.hospitalFirstFold = false;
        this.hospitalSecondFold = true;
        this.modalFilterContainer = false;
      },
      error => {
        console.log("failed submitting",error);
      });
  }
 

   
  submitForm(){}
  ngOnInit() {
    if((!!localStorage.getItem('pamClientId') && localStorage.getItem('pamClientId').toLowerCase() === "738113".toLowerCase())
      || (!! localStorage.getItem('companyName') && localStorage.getItem('companyName').toLowerCase().trim() === "National Foundation for India-CSOs".toLowerCase().trim())){
      this.isClinetNFI = true
    }
    
    this.setDataForResdirection();
    this.dataToSlide=0;
    this.selectInsurerName.length=0

    $(document).ready(function() {
      $('.carousel').carousel();
      })

  }

  

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
    
}
